/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `"Baskervville", serif;`,
  subHeading: `"MiltonOne", cursive;`,
  body: `"EB Garamond", serif;`,
  lora: `"Lora", serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    textStyle: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    textAlign: 'center',
    color: 'alternativeColorText',
    textTransform: 'uppercase',
    letterSpacing: '2px',
  },
  subHeading: {
    fontFamily: 'subHeading',
    textStyle: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    textAlign: 'center',
    color: 'secondaryColorText',
    margin: '12px 4px',
    lineHeight: '.9',
  },
  body: {
    fontFamily: 'body',
    textStyle: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
    letterSpacing: '-1px'
  },
  body_lv2: {
    fontFamily: 'body',
    textStyle: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
    letterSpacing: 'normal'
  },
};
